export default {"src":"/_next/static/media/img-attachment-file.a380b03a.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};